import {
  AddressAPIModel,
  EmployeeAPIModel,
  EmployeeBankDetailAPIModel,
  EmployeeComplianceReferenceDetailsAPIModel,
  EmploymentBasicDetailsAPIModel,
  PaginatedAPI,
  StatutoryDetailsAPIModel,
  employeeAPIModel
} from 'src/app/models/api.model'

export interface EmployeeState {
  details: PaginatedAPI<employeeAPIModel>
  id: string
  createdBy: string
  updatedBy: string
  status: string
  employeeCode: string
  companyEntityId: string
  companyGroupId: string
  firstName: string
  middleName: string
  lastName: string
  doj: string
  role: string
  gender: string
  dob: string
  nationality: string
  emailId: string
  secondaryEmailId: string
  mobileNumber: string
  alternateMobileNumber: string
  address: AddressAPIModel
  maritalStatus: string
  passwordAutoGenerated: boolean
  passwordExpirationDate: string
  notificationPreferences: string[]
  employeeEmploymentBasicDetails: EmploymentBasicDetailsAPIModel
  employeeStatutoryDetails: StatutoryDetailsAPIModel
  employeeComplianceReferenceDetailsOrchModel?: EmployeeComplianceReferenceDetailsAPIModel
  employeeBankDetailsOrchModel?: EmployeeBankDetailAPIModel
  employeeOrchModel?: EmployeeAPIModel
}

export const initialEmployeeState: EmployeeState = {
  details: undefined,
  id: '',
  createdBy: '',
  updatedBy: '',
  status: '',
  employeeCode: '',
  companyEntityId: '',
  companyGroupId: '',
  firstName: '',
  middleName: '',
  lastName: '',
  doj: '',
  role: '',
  gender: '',
  dob: '',
  nationality: '',
  emailId: '',
  secondaryEmailId: '',
  mobileNumber: '',
  alternateMobileNumber: '',
  address: undefined,
  maritalStatus: '',
  passwordAutoGenerated: false,
  passwordExpirationDate: '',
  notificationPreferences: [],
  employeeEmploymentBasicDetails: undefined,
  employeeStatutoryDetails: undefined
}
